import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux';
import configureStore, { history } from './redux/store';

ReactDOM.render(
    <Provider store={configureStore()}>
        <ConnectedRouter history={history}> { /* place ConnectedRouter under Provider */ }
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

